import styled from "@emotion/styled";
import { Theme } from "@silvertours/front-shared";
var AccordionWrapper = /*#__PURE__*/ styled("div", {
    target: "exfiqsh0"
})("margin-top:2rem;", Theme.mq("lg"), "{margin-top:2.5rem;}");
export { AccordionWrapper };
